// app/[locale]/HomeClient.tsx
"use client";

import VideoCover from "@/app/components/home/VideoCover";
import Honoring from "@/app/components/home/Honoring";
import PoonPhol from "@/app/components/home/PoonPhol";
import Bamboo from "@/app/components/home/Bamboo";
import OurTeam from "@/app/components/home/OurTeam";
import Map from "@/app/components/home/Map";
import News from "@/app/components/home/News";
import FooterContact from "@/app/components/FooterContact";
import HomeAdsPopup from "../components/HomeAdsPopup";

export default function HomeClient() {
  return (
    <>
      <HomeAdsPopup />
      <VideoCover />
      <Honoring />
      <PoonPhol />
      <Bamboo />
      <OurTeam />
      <Map />
      <News />
      <FooterContact />
    </>
  );
}
